﻿import { createFileRoute } from "@tanstack/react-router";
import { PaginaRota } from "@/paginas/pg_franquia/franquia-compras-recebidas";

export const Route = createFileRoute("/_authenticated/compras-recebidas")({
  head: () => ({
    meta: [
      { title: "Compras recebidas (depósito) — Milky Moo Palmares" },
      {
        name: "description",
        content: "Histórico das compras recebidas no depósito.",
      },
      { property: "og:title", content: "Compras recebidas (depósito) — Milky Moo Palmares" },
      {
        property: "og:description",
        content: "Histórico das compras recebidas no depósito.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: PaginaRota,
});
